'use client';

import { c as _c } from "react/compiler-runtime";
import type { AddFactiiiAction, AddFactiiiState } from '@shared/utils/helpers/addFactiii/formState';
import { OPTION_SECTIONS, type SectionKey } from '@shared/utils/helpers/addFactiii/sections';
import type { Dispatch } from 'react';
import { LUCIDE } from '../../../utils/lucideIcons';
import Switch from '../../UI/Switch';
import { NavRow, ToggleRow } from './parts';
type Props = {
  state: AddFactiiiState;
  dispatch: Dispatch<AddFactiiiAction>;
  type: 'USER' | 'SPACE';
  onOpen: (key: SectionKey) => void;
};

/**
 * The options screen: one line per setting, each opening its own screen. It is
 * a list rather than a stack of expanders so the whole configuration stays
 * readable at a glance and the modal never grows past the screen it is on.
 */
const OptionsView = t0 => {
  const $ = _c(21);
  const {
    state,
    dispatch,
    type,
    onOpen
  } = t0;
  const t1 = state.isPrivate ? "Private factiii" : "Public factiii";
  const t2 = state.isPrivate ? "Only you can tag it" : "Anyone can tag it";
  let t3;
  if ($[0] !== dispatch) {
    t3 = isPrivate => dispatch({
      type: "patch",
      patch: {
        isPrivate
      }
    });
    $[0] = dispatch;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== state.isPrivate || $[3] !== t3) {
    t4 = <Switch state={state.isPrivate} onChange={t3} />;
    $[2] = state.isPrivate;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t4) {
    t5 = <ToggleRow title={t1} subtitle={t2}>{t4}</ToggleRow>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onOpen || $[10] !== state || $[11] !== type) {
    let t7;
    if ($[13] !== type) {
      t7 = section => !(section.key === "space" && type === "SPACE");
      $[13] = type;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== onOpen || $[16] !== state) {
      t8 = section_0 => <NavRow key={section_0.key} icon={LUCIDE[section_0.icon]} label={section_0.title} value={section_0.summary(state)} attention={section_0.attention?.(state)} onClick={() => onOpen(section_0.key)} />;
      $[15] = onOpen;
      $[16] = state;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t6 = OPTION_SECTIONS.filter(t7).map(t8);
    $[9] = onOpen;
    $[10] = state;
    $[11] = type;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="space-y-1.5">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default OptionsView;